// extracted by mini-css-extract-plugin
export default {"list":"Requirements_list__16nRf"};